/* global axios */
import ApiClient from './ApiClient';

class MetaCampaignsCampaignsAPI extends ApiClient {
  constructor() {
    super('meta_campaigns/campaigns', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id, params = {}) {
    return axios.get(`${this.url}/${id}`, { params });
  }
}

export default new MetaCampaignsCampaignsAPI();
